import { memo } from 'react';

import { RotateCcw } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { telegramBotService } from 'v2/api/telegramBotService';
import { Popconfirm } from 'v2/components/popconfirm/Popconfirm';
import { handleHttpError } from 'v2/utils';

interface ResetDropRollButtonProps {
  onRevalidate: VoidFunction;
}

export const ResetDropRollButton = memo<ResetDropRollButtonProps>(({ onRevalidate }) => {
  const { trigger } = useSWRMutation('resetTelegramBotRoll', telegramBotService.resetTelegramBotRoll, {
    onSuccess: () => {
      onRevalidate();
      toast.success('Drop rolls have been dropped');
    },
    onError: handleHttpError,
  });

  return (
    <Popconfirm message="Are you sure that you want to reset drop roll date for all users?" onConfirm={trigger}>
      <Tooltip title="Reset Drop Rolls" placement="top">
        <IconButton color="primary">
          <RotateCcw width={20} height={20} />
        </IconButton>
      </Tooltip>
    </Popconfirm>
  );
});

ResetDropRollButton.displayName = 'ResetDropRollButton';
